// Generated by CoffeeScript 2.7.0
var FileMixin;

export default FileMixin = {
  data: function() {
    return {
      value: [],
      uploading: false
    };
  },
  computed: {
    valuePresent: function() {
      return _.some(this.value, function(file) {
        return file.id;
      });
    }
  },
  methods: {
    canPreview: function(file) {
      return file.extension === 'image';
    },
    canReload: function(file) {
      return file._error_message && (file.size <= file.limitSize) && !file.id;
    },
    fileChange: function(event, parsed_files) {
      var files;
      files = parsed_files || event.target.files;
      _.each(files, (file) => {
        return _.extend(file, {
          author: this.response.user,
          response: this.response
        });
      });
      this.attachments = new Skylark.Libs.Storage.Attachments(files);
      this._displayFiles(this.attachments);
      this.uploading = true;
      return this.attachments.upload({
        uploadCompleted: () => {
          event.target.value = null;
          this.attachments = null;
          this.uploading = false;
          return this.valueChange(this.value);
        }
      });
    },
    reloadFile: function(index) {
      var current_file;
      current_file = this.value[index];
      current_file._error_message = '';
      this.uploading = true;
      return current_file.upload({
        error: function(error, xhr) {
          return current_file._error_message = error.message;
        },
        progress: function(error, percentage) {
          return current_file._progress = percentage;
        },
        complete: () => {
          this.uploading = false;
          current_file._progress = 0;
          return this.valueChange(this.value);
        }
      });
    },
    removeFile: function(index, cb) {
      var callbacks, entry, file, ref;
      file = this.value[index];
      entry = this._findEntryByFile(file);
      callbacks = {
        success: (error, xhr) => {
          this.value.splice(index, 1);
          if (typeof cb === "function") {
            cb();
          }
          return this.valueChange(this.value);
        },
        error: function(error, xhr) {
          return console.log(error.message);
        }
      };
      // 来自缓存，文件已上传，但entry未保存，此时应调用接口删除附件
      if (entry && !entry.id) {
        return Skylark.Libs.Storage.Attachment.Delete(file.id, callbacks);
      } else {
        if ((ref = this.attachments) != null) {
          ref.removeItem(file);
        }
        this.value.splice(index, 1);
        if (typeof cb === "function") {
          cb();
        }
        return this.valueChange(this.value);
      }
    },
    _thumbnailUrl: function(file) {
      return `/attachments/${file.id}/download_url?variant=logo`;
    },
    _validate: function() {
      this.validatePresence();
      return this._validateUploading();
    },
    _validateUploading: function() {
      if (this.uploading) {
        return this._addError('有文件正在上传');
      }
    },
    _displayFiles: function(attachments) {
      return this.value.splice.apply(this.value, [this.value.length, 0].concat(attachments.files));
    },
    _findEntryByFile: function(file) {
      if (!file.id) {
        return null;
      }
      return _.find(this.entries, function(entry) {
        return entry.value_id.toString() === file.id.toString();
      });
    },
    _parseValueToEntries: function() {
      var _destroyed_entries, _result;
      _result = [];
      _destroyed_entries = _.filter(this.entries, (entry) => {
        return _.every(this.value, function(file) {
          var ref;
          return ((ref = file.id) != null ? ref.toString() : void 0) !== entry.value_id.toString();
        });
      });
      _.chain(this.value).filter(function(file) {
        return file.id;
      }).each((file) => {
        var old_entry;
        old_entry = this._findEntryByFile(file);
        if (old_entry) {
          old_entry = _.clone(old_entry);
          old_entry._destroy = false;
          old_entry.attachment = file.toJSON();
          return _result.push(old_entry);
        } else {
          return _result.push({
            value: file.name,
            value_id: file.id,
            _destroy: false,
            field_id: this.field.id,
            attachment: file.id ? file.toJSON() : null
          });
        }
      });
      return _result = _result.concat(_destroyed_entries.map(function(file) {
        _.clone(file);
        file._destroy = true;
        return file;
      }));
    },
    _initDefaultEntries: function(entries) {
      return entries || [];
    },
    _parseEntriesToValue: function(entries) {
      var files;
      files = _.chain(this.entries).filter(function(entry) {
        return !entry._destroy;
      }).pluck('attachment').compact().each((attachment) => {
        attachment.author = this.response.user;
        return attachment.response = this.response;
      }).value();
      return this.value = new Skylark.Libs.Storage.Attachments(files).files;
    }
  }
};
